<template>
    <!-- Navbar -->
    <nav class="main-header navbar nav_admin navbar-expand navbar-light navbar-light">
        <!-- Left navbar links -->
        <ul class="navbar-nav">
            <li class="nav-item">
                <a class="nav-link" data-widget="pushmenu" href="#" role="button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16">
                        <path id="menu_icon"
                            d="M205,1823a1,1,0,0,1,1-1h13a1,1,0,0,1,0,2H206A1,1,0,0,1,205,1823Zm19,6H206a1,1,0,0,0,0,2h18a1,1,0,0,0,0-2Zm-9,7h-9a1,1,0,0,0,0,2h9a1,1,0,0,0,0-2Z"
                            transform="translate(-205 -1822)" fill="#1a1818" />
                    </svg>
                </a>
            </li>
        </ul>

        <!-- Right navbar links -->
        <ul class="navbar-nav ml-auto">

            <!-- Messages Dropdown Menu -->
            <li class="nav-item dropdown">
                <a class="nav-link profile_link" data-toggle="dropdown" href="#">
                    <div class="d-flex align-items-center">
                        <div class="profile_image">
                            <img src="../assets/image/default_profile.svg" alt="">
                        </div>
                        <span class="mr-2">{{ user.name }}</span>
                        <i class="fas fa-angle-down"></i>
                    </div>
                </a>
                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                    <router-link to="/profile" class="dropdown-item d-flex align-items-center">
                        <i class="nav-icon mr-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 20 23">
                                <g id="profile_icon" transform="translate(-35 -356)">
                                    <circle id="Ellipse_7" data-name="Ellipse 7" cx="6" cy="6" r="6"
                                        transform="translate(39 356)" fill="#1a1818" />
                                    <path id="Rectangle_155" data-name="Rectangle 155"
                                        d="M5,0H15a5,5,0,0,1,5,5V6a3,3,0,0,1-3,3H3A3,3,0,0,1,0,6V5A5,5,0,0,1,5,0Z"
                                        transform="translate(35 370)" fill="#1a1818" opacity="0.5" />
                                </g>
                            </svg>
                        </i>
                        <p>Profile</p>
                    </router-link>
                    <div class="dropdown-divider"></div>
                    <a @click="logout()" class="dropdown-item d-flex align-items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="me-2" width="18" height="13.721"
                            viewBox="0 0 18 13.721">
                            <g id="logout_icon" transform="translate(-33.932 -435.466)">
                                <path id="Icon_awesome-sign-out-alt" data-name="Icon awesome-sign-out-alt"
                                    d="M19.178,11.963l-6,6a.859.859,0,0,1-1.465-.61V13.924H6.857A.855.855,0,0,1,6,13.07V9.641a.855.855,0,0,1,.857-.857h4.858V5.355a.859.859,0,0,1,1.465-.61l6,6A.864.864,0,0,1,19.178,11.963Z"
                                    transform="translate(32.505 430.971)" fill="#1a1818" opacity="0.5" />
                                <path id="Icon_awesome-sign-out-alt-2" data-name="Icon awesome-sign-out-alt"
                                    d="M6.858,17.785V16.357a.43.43,0,0,0-.428-.428h-3a1.143,1.143,0,0,1-1.143-1.141V7.929A1.143,1.143,0,0,1,3.429,6.786h3a.43.43,0,0,0,.43-.429V4.928a.43.43,0,0,0-.43-.428h-3A3.429,3.429,0,0,0,0,7.929v6.858a3.429,3.429,0,0,0,3.429,3.429h3a.43.43,0,0,0,.43-.431Z"
                                    transform="translate(33.932 430.97)" fill="#1a1818" />
                            </g>
                        </svg>
                        <p>Logout</p>
                    </a>
                </div>
            </li>
        </ul>
        <div class="wa">
            <a href="https://wa.me/6281131186888" target="_blank">
                <img src="../assets/image/wa-logo-text.png" width="100" height="100" alt="">
            </a>
        </div>
    </nav>
    <!-- /.navbar -->

</template>
<script>
import swal from "sweetalert"
import axios from "axios"

export default {
    name: "Header",
    data() {
        return {
            user: [],
            pendingorder: [],
        }
    },
    async mounted() {

        setTimeout(() => {
            axios.get(`investor/${localStorage.user_id}`)
                .then(response => {
                    // console.log('Profile: ', response.data.data)
                    this.user = response.data.data
                }).catch((err) => {
                    console.log('Error Profile: ', err)
                })

        }, 1000)
        try {
            var transaction = localStorage.getItem('transaction_id')
            // console.log(transaction);
            if (transaction == null) {
                // console.log('kklk');
                let pendingorderResponse = await axios.get(`investor/${localStorage.user_id}/pendingorder/`)
                // setTimeout(() => {
                this.loading = false
                this.pendingorder = pendingorderResponse.data.data
                let databaru = this.pendingorder.filter(x => {
                    if (x.broker_account_id == null) {
                        return x
                    }
                })
                if (databaru?.length > 0) {
                    localStorage.setItem('transaction_id', databaru[0].id)
                }

                // })
            }



        } catch (e) {
            // console.log('Error Robot: ', e.response)

            // alert(e.message)
        }

    },
    methods: {
        logout() {
            swal("Are You Sure to Log Out?", '', "info", {
                buttons: ["Cancel", "Logout"]
            }).then((res) => {
                if (res) {
                    this.$store.dispatch('auth/logout', {
                    })
                    this.$router.push('login')
                } else {
                    if (swal.close()) {
                        console.log("Cancel")
                    }
                }
            })

        }
    }
}
</script>
<style scoped>
/* .nav-admin{
    background: none;
    border-bottom: 0px !important;
} */
.nav_admin {
    background: white;
    border-bottom: 0;
    box-shadow: 0 5px 40px rgba(0, 0, 0, 0.05);
}

.nav_admin .navbar-nav {
    align-items: center;
}

.nav_admin .navbar-nav .profile_link {
    padding-top: 0;
    padding-bottom: 0;
}

.nav_admin .navbar-nav .profile_image {
    width: 34px;
    height: 34px;
    margin-right: 10px;
    margin-top: 2px;
}

.nav_admin .navbar-nav .profile_image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
}

/* .nav_admin .navbar-nav .nav-link svg path{
    fill: var(--dark-grey);
    transition: all 0.3s ease;
}
.nav_admin .navbar-nav .nav-link:hover svg path{
    fill: var(--red);
} */
</style>